import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
	createPersistedState({
		key: 'auth',
		// only save state of auth module
		paths: ["auth"],
		//storage: window.sessionStorage
	})(store);
}